<template lang="pug">
v-layout.box-documentos-desktop(column align-center)
  //- LOADER PROCESS
  v-dialog(v-model="loader.flag" persistent width="300")
    v-card(color="primary" dark="")
      v-card-text
        | {{loader.text}}
        v-progress-linear.mb-0(indeterminate="" color="white")
  v-flex(style="margin-bottom:1em;")
    span Selecciona y descarga tus documentos.
  v-flex.box-documentos-container
    v-layout(row wrap style="width: 21.5em; margin-left: 15px;")
      v-flex.icon-solicitud(xs6 v-for="documento in documentos" :key="documento.id")
        CardDocumentoEndoso(
          @cardMethod="descargarDocumento(documento)"
          :text="documento.filename"
          :icon="iconDocumentoPdf"
          :icon2="iconDocumentoPdf"
          )
</template>

<script>
import * as d3 from 'd3'
import CardDocumentoEndoso from './CardDocumentoEndoso.vue'
import { mapActions } from 'vuex'

export default {
  props: [
    'taggeo',
    'id',
    'documentos'
  ],
  data () {
    return {
      iconDocumentoPdf: require('./../../assets/icons-mis-seguros/icon-pdf-documento-endoso.svg'),
      loader: {
        flag: false,
        text: ''
      },
      solicitudes: [],
      metadata: {}
    }
  },
  components: {
    CardDocumentoEndoso
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    ...mapActions('endorsements', ['downloadPdfEndorsement']),
    descargarDocumento (documento) {
      const self = this
      self.loader.flag = true
      self.loader.text = 'Descargando documento...'
      self.downloadPdfEndorsement({
        reqId: documento.requirement_id,
        docId: documento.id,
        state: documento.state,
        filename: documento.url_file
      }).then(res => {
        self.loader.flag = false
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de documentos de endoso',
            metadata: self.metadata
          })
        }, 3000)
      }).catch(err => {
        self.loader.flag = false
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de documentos de endoso',
            metadata: { ...self.metadata, error: err }
          })
        }, 3000)
      })
    }
  },
  mounted () {
    let self = this
    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Documentos de endoso', metadata: self.metadata})

    d3.selectAll('.box-documentos-desktop .icon-solicitud')
      .style('opacity', '0')
      .transition().delay(function (d, i) { return i * 200 }).duration(300)
      .style('opacity', '1')

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop',
        'seccion': 'documentos de endoso'
      }
    })
  }
}
</script>

<style scoped>
@media (min-width : 1024px) {

  .box-documentos-desktop .icon-solicitud {
    max-width: fit-content;
    margin: 0.5em 0.5em;
  }

  .box-documentos-desktop {
    padding: 1em 1em;
  }

  .box-documentos-container {
    min-height: 16em;
    max-height: 30em;
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/DocumentosEndoso.vue